let elements = {
  staticPos: {
    x: [0, 1400],
    y: 339,
  },
  puzzle: {
    src: 'games/page007_game1/img/1.jpg',
    numerOfX: 4,
    numerOfY: 3,
  },
};

export default elements;
